// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'

Vue.config.productionTip = false;


// Initialize Firebase
let config = {
  apiKey: "AIzaSyCJh71uIEDWj38pdn5A5-Xd9y0hlew4VO4",
  authDomain: "wat-help-d0241.firebaseapp.com",
  databaseURL: "https://wat-help-d0241.firebaseio.com",
  projectId: "wat-help-d0241",
  storageBucket: "wat-help-d0241.appspot.com",
  messagingSenderId: "996601600606"
};
firebase.initializeApp(config);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js